'use strict'

module.exports = footnoteReference

var u = require('unist-builder')

function footnoteReference(h, node) {
  var footnoteOrder = h.footnoteOrder
  var identifier = String(node.identifier)

  if (footnoteOrder.indexOf(identifier) === -1) {
    footnoteOrder.push(identifier)
  }

  return h(node.position, 'sup', {id: 'fnref-' + identifier}, [
    h(node, 'a', {href: '#fn-' + identifier, className: ['footnote-ref']}, [
      u('text', node.label || identifier)
    ])
  ])
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/node_modules/mdast-util-to-hast/lib/handlers/footnote-reference.js
// module id = S8+g
// module chunks = 0